import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { AuthStore } from '../stores/auth.store';

export const isLoggedGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
): boolean | UrlTree => {
  const authStore = inject(AuthStore);
  const router = inject(Router);

  const isAuth = authStore.isAuthenticated();
  if (isAuth) {
    return true;
  }

  const redirect = state.url.split('?')[0];
  const params = route.queryParams;

  // Caso token + email nei parametri
  if (params?.['token'] && params?.['email']) {
    return router.createUrlTree(['/login'], {
      queryParams: {
        email: params['email'],
        redirect,
      },
    });
  }

  // Caso redirect standard
  if (redirect && redirect !== '/') {
    return router.createUrlTree(['/login'], {
      queryParams: { redirect },
    });
  }

  // Default
  return router.createUrlTree(['/login']);
};
